const {fetch} = global;

export const createReview = async ({
	sku,
	product_title,
	product_url,
	email,
	display_name,
	review_content,
	review_score,
	review_title,
}) => await fetch(`${process.env.GATSBY_FUNCTION_PATH}/create-review`, {
	method: 'POST',
	body: JSON.stringify({
		sku,
		product_title,
		product_url,
		display_name,
		email,
		review_content,
		review_title,
		review_score,
		domain: process.env.GATSBY_SHOPIFY_DOMAIN,
	})
});